import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "wizard-navigation_item--number" }, "1", -1)
const _hoisted_2 = { class: "wizard-navigation_item--title" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "wizard-navigation_item--number" }, "2", -1)
const _hoisted_5 = { class: "wizard-navigation_item--title" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "wizard-navigation_item--number" }, "3", -1)
const _hoisted_8 = { class: "wizard-navigation_item--title" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "wizard-navigation_item--number" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon-Tickmark" })
], -1)
const _hoisted_11 = { class: "wizard-navigation_item--title" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["wizard-navigation_item position-relative", {active: _ctx.$route.name === 'TravellerDetails'}]),
      style: {"cursor":"pointer"},
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.header.go(1)))
    }, [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.$t("travel")) + " ", 1),
          _hoisted_3,
          _createTextVNode(" " + _toDisplayString(_ctx.$t("details")), 1)
        ])
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["wizard-navigation_item position-relative", {active: _ctx.$route.name === 'CompareQuotes'}]),
      style: {"cursor":"pointer"},
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.header.go(2)))
    }, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.$t("compare")) + " ", 1),
          _hoisted_6,
          _createTextVNode(" " + _toDisplayString(_ctx.$t("quotes")), 1)
        ])
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["wizard-navigation_item position-relative", {active: _ctx.$route.name === 'ReviewDetails'}]),
      style: {"cursor":"pointer"},
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.header.go(4)))
    }, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.$t("review")) + " ", 1),
          _hoisted_9,
          _createTextVNode(" " + _toDisplayString(_ctx.$t("details")), 1)
        ])
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["wizard-navigation_item position-relative", {active: _ctx.$route.name === 'CheckoutDetails'}]),
      style: {"cursor":"pointer"},
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.header.go(5)))
    }, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.$t("purchase")) + " ", 1),
          _hoisted_12,
          _createTextVNode(" " + _toDisplayString(_ctx.$t("insurance")), 1)
        ])
      ])
    ], 2)
  ], 64))
}